import { get, post, put } from "../Config";
import config from "util/config";
import {
  getNewApiBaseUrl,
  getWithNewApiFallback,
  postWithNewApiFallback,
  putWithNewApiFallback,
} from "../newApiFallback";

// POST
// export function OtpRequest({ data }) {
//   return post({ url: `/api/v1/customer/otp_request`, data, timeOut: 20000 });
// }
// export function OtpVerify({ data }) {
//   return post({ url: `/api/v1/customer/otp_verify`, data, timeOut: 20000 });
// }

export function AccountAuth({ data }) {
  return post({ url: `/api/v1/customer/account_auth`, data, timeOut: 20000 });
}
export function AccountCreate({ data }) {
  return post({ url: `/api/v1/customer/account_create`, data, timeOut: 20000 });
}
export function AccountUpdate({ data }) {
  return post({ url: `/api/v1/customer/account_update`, data, timeOut: 20000 });
}

// GET
export function CheckIdCardExists({ params }) {
  return get({ url: `/api/v1/customer/idcard_exists`, params });
}
export function CheckAccountExists({ params }) {
  return get({ url: `/api/v1/customer/account_exists`, params });
}
export function AccountSearch({ params }) {
  return get({ url: `/api/v1/customer/account_search`, params });
}

// KOALA API
// GET
export function GetSearchCustomerData({ params }) {
  return getWithNewApiFallback(`/api/koala/v1/customer`, { params }, "register");
}
export function AddressInfo() {
  return getWithNewApiFallback(`/api/koala/v1/address`, {}, "register");
}
export function QuestionnaireSearch() {
  return getWithNewApiFallback(`/api/koala/v1/questionnaire-main`, {}, "register");
}
export function GetCustomerData({ id }) {
  return getWithNewApiFallback(`/api/koala/v1/customer/${id}`, {}, "register");
}

export function GetMe() {
  const newApiUrl = config.config().NEW_API_URL;
  return get({ url: `/api/me`, baseURL: newApiUrl, timeOut: 20000 });
}
export function CheckRef({ params }) {
  return getWithNewApiFallback(`/api/koala/v1/check`, { params }, "register");
}
export function CheckCodeLegacy({ params }) {
  return get({ url: `/api/koala/v1/check-sku`, params });
}

export function CheckCodeNew({ params }) {
  return get({
    url: `/api/koala/v1/check-sku`,
    baseURL: getNewApiBaseUrl(),
    params,
  });
}

/** @deprecated use checkCodeWithFallback — kept for direct legacy calls */
export function CheckCode({ params }) {
  return CheckCodeLegacy({ params });
}

export function CheckSkuFormLegacy({ data }) {
  return post({ url: `/api/koala/v1/check-sku-form`, data, timeOut: 20000 });
}

export function CheckSkuFormNew({ data }) {
  return post({
    url: `/api/koala/v1/check-sku-form`,
    baseURL: getNewApiBaseUrl(),
    data,
    timeOut: 20000,
  });
}

/** @deprecated use checkSkuFormWithFallback — kept for direct legacy calls */
export function CheckSkuForm({ data }) {
  return CheckSkuFormLegacy({ data });
}

export function GetPointHistory({ params }) {
  return get({ url: `/api/koala/v1/point-history`, params });
}

export function GetPointHistoryNew({ params }) {
  return get({
    url: `/api/koala/v1/point-history`,
    baseURL: getNewApiBaseUrl(),
    params,
  });
}

export function CheckDupReceipt({ params }) {
  return get({ url: `api/koala/v1/check-receipt`, params });
}

export function GetUploadReceiptSchedual({ params }) {
  return get({ url: `/api/koala/v1/upload-receipt-schedual`, params });
}

// /api/koala/v1/check-sku?codeSku=07290XZNWDXZA&customerId=1

// POST
export function CreateCustomer({ data }) {
  return post({ url: `/api/koala/v1/customer/`, data, timeOut: 20000 });
}
export function CreateQuestion({ data }) {
  return post({
    url: `/api/koala/v1/customer-questionnaire`,
    data,
    timeOut: 20000,
  });
}
export function CreatePointHistory({ data }) {
  return post({ url: `/api/koala/v1/point-history`, data, timeOut: 20000 });
}

export function SubmitScanPointLegacy({ data }) {
  return post({ url: `/api/koala/v1/pointHistory`, data, timeOut: 20000 });
}

export function SubmitScanPointNew({ data }) {
  return post({
    url: `/api/koala/v1/scan-point`,
    baseURL: getNewApiBaseUrl(),
    data,
    timeOut: 20000,
  });
}

/** @deprecated use submitScanPointWithFallback — kept for direct legacy calls */
export function CreatePointHistoryAndSticker({ data }) {
  return SubmitScanPointLegacy({ data });
}

export function CreateReciept({ data }) {
  return post({
    url: `/api/koala/v1/upload-receipt-history`,
    data,
    timeOut: 20000,
  });
}
export function CreateTransactionCustomer({ data }) {
  return postWithNewApiFallback(
    `/api/koala/v1/createCustomer`,
    { data, timeOut: 20000 },
    "register"
  );
}

export function OtpVerify({ data }) {
  return post({
    url: `/api/sb/v1/tbs/otp_verify`,
    baseURL: getNewApiBaseUrl(),
    data,
    timeOut: 20000,
  });
}
export function OtpRequest({ data }) {
  return post({
    url: `/api/sb/v1/tbs/otp_request`,
    baseURL: getNewApiBaseUrl(),
    data,
    timeOut: 20000,
  });
}

// PUT
export function UpdateCustomer({ data, id }) {
  return put({
    url: `/api/koala/v1/customer/${id}`,
    baseURL: getNewApiBaseUrl(),
    data,
    timeOut: 20000,
  });
}

export function UpdateTransactionCustomer({ data, id }) {
  return putWithNewApiFallback(
    `/api/koala/v1/updateCustomer/${id}`,
    { data, timeOut: 20000 },
    "register"
  );
}
